var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"app_container"},[_c('div',{staticClass:"nav"},[_c('HeaderBar')],1),_c('div',{staticClass:"main"},[_c('router-view')],1),(_vm.showFooter)?_c('div',{staticClass:"footer"},[_c('Footer')],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }